/*
 * @Author: 郭洪宇 guohongyu@chinasofti.com
 * @Date: 2022-07-18 13:59:51
 * @LastEditors: ghy
 * @LastEditTime: 2023-08-09 14:14:53
 * @FilePath: \cigbus-vue-cdp-ma\src\api\objectRelationshipManage.js
 * @Description: 
 */
import axios from './index'
export const API_MAIN = '/api'

/**
 * @description: 仪器样例
 * @param {
 * }
 * @return {*}
 */
export const findCheckedEquipPage = (data) => {
    return axios.request({
        url: `${API_MAIN}/findCheckedEquipPage`,
        method: 'post',
        data
    })
}

/**
 * @description: 全部学科
 * @param {
* }
* @return {*}
*/
export const findGwSubjectList = (data) => {
   return axios.request({
       url: `${API_MAIN}/findGwSubjectList`,
       method: 'post',
       data
   })
}

/**
 * @description: 全部学段
 * @param {
* }
* @return {*}
*/
export const findGradeSectionList = (data) => {
   return axios.request({
       url: `${API_MAIN}/findGradeSectionList`,
       method: 'post',
       data
   })
}

/**
 * @description: 仪器使用参考属性
 * @param {
* }
* @return {*}
*/
export const findUseRefList = (data) => {
   return axios.request({
       url: `${API_MAIN}/findUseRefList`,
       method: 'post',
       data
   })
}
/**
 * @description: 详情
 * @param {
* }
* @return {*}
*/
export const findEquipDetail = (data) => {
   return axios.request({
       url: `${API_MAIN}/findEquipDetail`,
       method: 'post',
       data
   })
}




// WEBPACK FOOTER //
// ./src/api/equip.js